
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "6de098ca49dc9cc992d6c8373258589448f43976",
  "nuxt": {
    "buildId": "66fbb4fb-1f24-4eb5-9a54-d56792230c84"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
